import React from "react";
import Dbm from "dbm";

export default class FacilitiesMap extends Dbm.react.BaseObject {
    _construct() {
        super._construct();

        this.item.setValue("element", document.createElement("div"));
        this.item.setValue("widthElement", null);

        this.item.requireProperty("loaded", false);
        this.item.requireProperty("mapsLoaded", false);

        let scriptLoader = Dbm.loading.loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCpquWnwIjrMFT1ixYZCYSIA_7Dlf54DuQ&libraries=places,geometry,marker");
        Dbm.flow.runWhenMatched(scriptLoader.item.properties.status, 1, Dbm.commands.callFunction(this._mapStatus.bind(this), [scriptLoader]));

        let elementSize = new Dbm.flow.updatefunctions.dom.ElementSize();
        
        this.item.setValue("elementSize", elementSize);
        elementSize.input.properties.element.connectInput(this.item.properties.widthElement);
        elementSize.start();

    }

    _mapStatus(aLoader) {
        //console.log("_mapStatus");
        //console.log(aLoader);

        this.item.mapsLoaded = true;
        this._createMap();

    }

    _createMap() {

        let element = this.item.element;
        element.classList.add("full-size");

        let facilities = this.item.locations;

        let location = {latitude: this.getPropValue("latitude"), longitude: this.getPropValue("longitude")};
    
        let centerLocation = new google.maps.LatLng(1*location.latitude, 1*location.longitude);

        let zoom = 13;

        if(window.innerWidth < 600) {
            zoom = 12;
        }

    
        this._map = new google.maps.Map(element, {zoom: zoom, center: centerLocation, "mapTypeControl": false, "streetViewControl": false, "mapId": "footerMap"});
            
            if(location) {
                let markerLocation = new google.maps.LatLng(1*location.latitude, 1*location.longitude);

                let markerData = {
                    "position": markerLocation,
                    "map": this._map
                };
    
                let marker = new google.maps.marker.AdvancedMarkerElement(markerData);

            }
    }

    componentDidMount() {
        //console.log("componentDidMount");
		
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    componentDidUpdate() {
        //console.log("componentDidUpdate");
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    _renderMainElement() {

		let returnElement = this._mainElement(<div className="facilities-map" id="map">
			<div className="full-size" ref={this.createRef("holderElement")} />
		</div>);

        return returnElement;
    }
}